import { Component } from '@theme/component';

const SELECTORS = {
  card: '[data-month]',
};

const CLASSES = {
  btnActive: 'button-tertiary',
  btnInactive: 'button-stroke',
  hidden: 'hidden',
};

/**
 * @typedef {{ buttons: HTMLButtonElement[] }} EventsFilterRefs
 */

/**
 * A pill-style filter bar that shows/hides event cards by month.
 *
 * Reads `data-target` to find the ID of the events grid container.
 * Toggles the `hidden` class on cards whose `data-month` does not
 * match the selected filter.
 *
 * @extends {Component<EventsFilterRefs>}
 */
class EventsFilterComponent extends Component {
  /**
   * Handles a filter button click.
   *
   * Called via declarative event delegation: `on:click="/selectFilter"`.
   *
   * @param {MouseEvent} event
   */
  selectFilter(event) {
    const target = /** @type {HTMLButtonElement} */ (event.target);
    const filter = target.dataset.filter || 'all';

    for (const button of this.refs.buttons || []) {
      button.classList.toggle(CLASSES.btnActive, button === target);
      button.classList.toggle(CLASSES.btnInactive, button !== target);
    }

    const cards = document.querySelectorAll(SELECTORS.card);
    if (cards.length === 0) return;

    for (const card of cards) {
      const typedCard = /** @type {HTMLElement} */ (card);
      const months = (typedCard.dataset.month || '').split('|');
      typedCard.classList.toggle(CLASSES.hidden, filter !== 'all' && !months.includes(filter));
    }
  }
}

if (!customElements.get('events-filter-component')) {
  customElements.define('events-filter-component', EventsFilterComponent);
}
